<template>
  <div id="myTabContent" class="tab-content">
    <!--API申请指南-->
    <div class="step-title apply">加盟费：3000/年，月订单量达1000单，全额退还，点击<span @click="routerTo('apply')">申请成为开发者</span>，调用API</div>
    <div class="step-title">开放平台操作流程图：</div>
    <div class="img-div"><img src="../../../../assets/img/document/process.png" alt=""></div>
    <div class="step-title">第一步：登录/注册网站会员</div>
    <div class="step-tip">打开网站，注册/登录系统。<!--网站地址：<span @click="routerTo('login')">http://www.juzihaohuo.com/index/user/login</span>--></div>
    <div class="img-div"><img src="../../../../assets/img/document/login.png" alt=""></div>
    <div class="step-title">第二步：点击左侧菜单栏【我的应用】，页面会提示先进行开发者申请。审核时间：12小时内。</div>
    <div class="img-div"><img src="../../../../assets/img/document/dev_apply.png" alt=""></div>
    <div class="step-title">第三步：注册应用，获取appkey和secret。系统会为每个应用提供一个唯一的用户key，该key将用来对您的开发者身份进行验证，请您妥善保管。</div>
    <div class="img-div"><img src="../../../../assets/img/document/application.png" alt=""></div>
    <div class="guide-title">创建应用及添加接口指南</div>
    <!--公共请求参数-->
    <div class="box-padding">
      <div class="box-title">公共参数：</div>
      <div class="box-explain">调用任何一个API都必须传入的参数，目前支持的公共参数有：</div>
      <div class="panel panel-default">
        <table class="table table-striped table-hover" width="100%">
          <thead>
            <tr>
              <th><div class="th-inner">名称</div><div class="fht-cell"></div></th>
              <th><div class="th-inner">类型</div><div class="fht-cell"></div></th>
              <th><div class="th-inner">是否必须</div><div class="fht-cell"></div></th>
              <th><div class="th-inner">说明</div><div class="fht-cell"></div></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>是</td>
              <td>API接口名称</td>
            </tr>
            <tr>
              <td>appkey</td>
              <td>String</td>
              <td>是</td>
              <td>POP分配给应用的AppKey</td>
            </tr>
            <tr>
              <td>timestamp</td>
              <td>Integer</td>
              <td>是</td>
              <td>UNIX时间戳，例如：1592386937</td>
            </tr>
            <tr>
              <td>format</td>
              <td>String</td>
              <td>否</td>
              <td>响应格式。默认为json格式，可选值：xml，json。</td>
            </tr>
            <tr>
              <td>version</td>
              <td>String</td>
              <td>否</td>
              <td>API协议版本，可选值：2.0。</td>
            </tr>
            <tr>
              <td>sign</td>
              <td>String</td>
              <td>是</td>
              <td>API输入参数签名结果，签名算法参照下面的介绍。</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--公共请求参数-->
    <!--业务参数-->
    <div class="box-padding">
      <div class="box-title">业务参数：</div>
      <div class="box-explain">API调用除了必须包含公共参数外，如果API本身有业务级的参数也必须传入，每个API的业务级参数请考API文档说明。</div>
    </div>
    <!--业务参数-->
    <!--签名算法-->
    <div class="box-padding">
      <div class="box-title">签名算法：</div>
      <div class="box-explain">
        为了防止API调用过程中被黑客恶意篡改，调用任何一个API都需要携带签名，POP服务端会根据请求参数，对签名进行验证，签名不合法的请求将会被拒绝。
      </div>
      <div class="box-explain">POP目前支持的签名算法为：MD5(sign_method=md5)，签名大体过程如下：</div>
      <div class="box-explain">1-所有参数进行按照首字母先后顺序排列</div>
      <div class="box-explain">2-把排序后的结果按照参数名+参数值的方式拼接</div>
      <div class="box-explain">3-拼装好的字符串首尾拼接APP_SECRET进行md5加密后转大写，secret的值是礼品开放平台后台分配的APP_SECRET</div>
      <div style="padding:20px 0 5px 0;">调用示例</div>
      <div class="box-explain">1、输入参数为</div>
      <pre class="pre_array">array (
    'type'=&gt;'gift.goods.list.get',
    'appkey' =&gt; 'ID7VWBqrdNIeR',
    'format' =&gt; 'json',
    'version'=&gt;'2.0',
    'timestamp' =&gt; '1592445858',
    'goods_name' =&gt; '全国包邮-眼镜喷雾',
    'sort' =&gt; 'price_asc',
    'page' =&gt; '1',
    'page_size' =&gt; '20'
)</pre>
      <div class="box-explain">2、按首字母升序排列</div>
      <pre class="pre_array">array (
    'appkey' =&gt; 'ID7VWBqrdNIeR',
    'format' =&gt; 'json',
    'goods_name' =&gt; '全国包邮-眼镜喷雾',
    'page' =&gt; '1',
    'page_size' =&gt; '20'
    'sort' =&gt; 'price_asc',
    'timestamp' =&gt; '1592445858',
    'type'=&gt;'gift.goods.list.get',
    'version'=&gt;'2.0'
)</pre>
      <div class="box-explain">连接字符串，并在首尾加上APP_SECRET，假设APP_SECRET为testSecret，如下：</div>
      <div class="box-explain">testSecretappkeyID7VWBqrdNIeRformatjsongoods_name全国包邮-眼镜喷雾page1page_size20sortprice_asctimestamp1592550917typegift.goods.list.getversion2.0testSecret</div>
      <div class="box-explain">3、生成签名 sign</div>
      <div class="box-explain">strtoupper(md5(testSecretappkeyID7VWBqrdNIeRformatjsongoods_name全国包邮-眼镜喷雾page1page_size20sortprice_asctimestamp1592550917typegift.goods.list.getversion2.0testSecret)) = AD5F8B7C42F0B428243782D62ABF55EB</div>
      <div class="box-explain">4、拼装API请求</div>
      <div class="box-explain">{{host}}/api/router?type=gift.goods.list.get&amp;appkey=ID7VWBqrdNIeR&amp;format=json&amp;version=2.0×tamp=1592445858&amp;goods_name=全国包邮-眼镜喷雾&amp;sort=price_asc&amp;page=1&amp;page_size=20&amp;sign=AD5F8B7C42F0B428243782D62ABF55EB</div>
    </div>
    <div class="box-padding">
      <div class="box-title">注意事项：</div>
      <div class="box-explain">
        1） 所有的请求和响应数据编码皆为utf-8格式，url里的所有参数值请做urlencode编码。如果请求的Content-Type是 application/x-www-form-urlencoded，所有参数值也做urlencode编码；如果是multipart/form-data格式，每个表单字段的参数值无需编码,但每个表单字段的charset部分需要指定为utf-8
      </div>
      <div class="box-explain">
        2） 如果指定接口返回数据格式为JSON，请指明header头Content-Type: application/json。
      </div>
    </div>
    <!--签名算法-->
    <!--API申请指南-->
  </div>
</template>

<script>
export default {
  name: 'DocumentGuide',
  data() {
    return{
      host: '{{host}}'
    }
  },
  methods: {
    routerTo(type) {
      if (type === 'apply') {
        this.$router.push('/pc/document/user').catch(err => { err })
      } else if (type === 'login') {
        this.$router.push('/pc/document/user').catch(err => { err })
      }
    }
  }
}
</script>

<style scoped>
.tab-content{
  padding-bottom: 30px;
  color: #333333;
  width: 75%;
}
.tab-content .step-title{
  line-height: 26px;
  font-weight: bolder;
  padding: 10px 0;
}
.tab-content .apply{
  padding-top: 15px;
}
.tab-content .step-title span{
  font-size:16px;
  color: #0e90d2;
  text-decoration: underline;
  cursor: pointer;
}
.tab-content .step-tip{
  line-height: 35px;
}
.tab-content .step-tip span{
  color: #0e90d2;
  text-decoration: underline;
  cursor: pointer;
}
.tab-content .img-div img{
  max-width: 100%;
  max-height: 100%;
}
.tab-content .guide-title{
  color: #0e90d2;
  font-size: 16px;
  font-weight: bolder;
  margin-top: 50px;
}
.box-padding {
    padding-top: 20px;
}
.box-padding .box-title{
    font-size: 16px;
    font-weight: bolder;
    line-height: 30px;
}
.box-padding .box-explain{
    line-height: 25px;
    word-break:break-all;
}
.box-padding .panel-default {
    padding: 0;
}
.table > thead > tr > th {
    border-bottom: 2px solid #f4f4f4;
}
.panel-default{
   border: 1px solid #ddd;
    border-radius: 3px;
    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    border-top: 1px solid #f4f4f4;
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
}
.table-striped > tbody > tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}
pre{
    display: block;
    padding: 8px;
    margin: 0 0 8.5px;
    font-size: 11px;
    line-height: 1.42857143;
    word-break: break-all;
    word-wrap: break-word;
    color: #333333;
    background: #F4F4F4;
    border: 1px solid #ccc;
    border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/document/guide/index.vue